module.exports = __webpack_public_path__ + "img/p-41.a609c30b.png";